/* ============================================================
   SAVER PRO — brand behaviours
   Scroll reveal for bespoke GSP content (.sp-reveal). Self-contained,
   dependency-free, and additive to the base theme's own motion.
   Honours prefers-reduced-motion and the <body data-scroll-reveal> gate,
   and re-scans on shopify:section:load so it works in the editor.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scan(root) {
    if (!document.body || !document.body.hasAttribute('data-scroll-reveal')) return;
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('.sp-reveal:not(.is-in)');
    if (!els.length) return;

    // Reduced motion or no IO support → show everything at once.
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Theme editor: re-scan the section that was just (re)loaded.
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

/* ============================================================
   SAVER PRO — Learning page TOC scroll-spy
   Highlights the active table-of-contents link as chapters scroll
   through the viewport. Progressive enhancement: without JS (or IO)
   every link simply stays visible and clickable.
   ============================================================ */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;

  function initLearn(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var learns = scope.querySelectorAll ? scope.querySelectorAll('.sp-learn') : [];
    for (var n = 0; n < learns.length; n++) {
      (function (learn) {
        var links = learn.querySelectorAll('.sp-pillar__toc-link');
        var sections = learn.querySelectorAll('.sp-pillar__article > section[id]');
        if (!links.length || !sections.length) return;

        var byId = {};
        for (var i = 0; i < links.length; i++) {
          var href = links[i].getAttribute('href') || '';
          if (href.charAt(0) === '#') byId[href.slice(1)] = links[i];
        }

        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var link = byId[entry.target.id];
            if (!link) return;
            for (var k = 0; k < links.length; k++) links[k].classList.remove('is-active');
            link.classList.add('is-active');
          });
        }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });

        for (var s = 0; s < sections.length; s++) io.observe(sections[s]);
      })(learns[n]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initLearn(); });
  } else {
    initLearn();
  }
  document.addEventListener('shopify:section:load', function (e) { initLearn(e.target); });
})();

/* ============================================================
   SAVER PRO — Hero Tab (content-switching tabs)
   Clicking an enabled tab shows its panel and hides the others.
   Disabled tabs render as inert <span>s (no [data-tab-target]) and are
   never activated. Without JS the first enabled panel stays visible.
   Re-inits on shopify:section:load for the theme editor.
   ============================================================ */
(function () {
  'use strict';

  function initHeroTabs(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var groups = scope.querySelectorAll('[data-herotab]');
    for (var i = 0; i < groups.length; i++) {
      (function (group) {
        var tabs = group.querySelectorAll('[data-tab-target]');
        var panels = group.querySelectorAll('[data-tab-panel]');
        if (!tabs.length || !panels.length) return;

        function activate(id) {
          for (var p = 0; p < panels.length; p++) {
            var on = panels[p].getAttribute('data-tab-panel') === id;
            panels[p].classList.toggle('is-active', on);
            if (on) { panels[p].removeAttribute('hidden'); } else { panels[p].setAttribute('hidden', ''); }
          }
          for (var t = 0; t < tabs.length; t++) {
            var active = tabs[t].getAttribute('data-tab-target') === id;
            tabs[t].classList.toggle('sp-worldswitch__tab--active', active);
            tabs[t].setAttribute('aria-selected', active ? 'true' : 'false');
          }
        }

        for (var t = 0; t < tabs.length; t++) {
          tabs[t].addEventListener('click', function () {
            activate(this.getAttribute('data-tab-target'));
          });
        }
      })(groups[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initHeroTabs(); });
  } else {
    initHeroTabs();
  }
  document.addEventListener('shopify:section:load', function (e) { initHeroTabs(e.target); });
})();

/* ============================================================
   SAVER PRO — Scroll-down hint
   Clicking the slideshow scroll-down indicator smoothly scrolls to the
   next section (or ~one viewport down). Event-delegated so it works for
   sections (re)loaded in the theme editor.
   ============================================================ */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-sp-scrolldown]') : null;
    if (!el) return;
    var section = el.closest('.shopify-section') || el.closest('.section');
    var next = section ? section.nextElementSibling : null;
    var top;
    if (next) {
      top = next.getBoundingClientRect().top + window.pageYOffset;
    } else {
      top = window.pageYOffset + (window.innerHeight * 0.9);
    }
    window.scrollTo({ top: top, behavior: 'smooth' });
  });
})();
